<div class="grid grid-cols-2 gap-4 sm:grid-cols-4">
  @for (card of cards; track card.label) {
    <div class="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4 flex items-start gap-3">
      <!-- Icono -->
      <div class="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-xl {{ card.bg }}">
        <span class="w-5 h-5 {{ card.color }}" [innerHTML]="card.icon"></span>
      </div>
      <!-- Valores -->
      <div class="min-w-0">
        <p class="text-xl font-bold text-gray-800 dark:text-white/90 leading-tight">
          {{ card.value | number }}
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate">{{ card.label }}</p>
      </div>
    </div>
  }
</div>
